import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { OrderAdjustmentsReportList } from './OrderAdjustmentsReportList';

export const orderAdjustmentsReportResource: ResourceProps = {
  name: Resources.OrderAdjustmentsReport,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: OrderAdjustmentsReportList,
};
